import React from 'react';

import {v4 as uuid} from 'uuid';

import LinkPreviewComponent from '@common/react/components/UI/LinkPreview/LinkPreview';
import {PreviewInfo} from '@common/react/objects/LinkPreview';
import useRequest from '@common/react/hooks/useRequest';

interface LinkPreviewGroupProps {
	linkPreviewId: string;
	links: string[];
	className?: string;
	previewRequest?: (onSuccess?: (infos: PreviewInfo[]) => void, onError?: (err) => void) => void;
	onProcess?: () => void;
	onSuccess?: () => void;
	onError?: () => void;
}

const LinkPreviewGroup: React.FC<LinkPreviewGroupProps> = ({linkPreviewId, links, className, previewRequest, onProcess, onSuccess, onError}) => {
	const request = useRequest();
	const [previewInfos, setPreviewInfos] = React.useState<{link: string, item?: PreviewInfo}[]>(() => 
		links.map(link => ({link})));
	
	React.useEffect(() => {
		if (links.length > 0) {
			getLinkInfo(links);
		}
	}, [links]);

	const getLinkInfo = React.useCallback((links: string[]) => {
		onProcess && onProcess();
		if (previewRequest) {
			previewRequest(handleSuccess, handleError);
		} else {
			request<any>('linkPreview', {linkPreviewId, links})
				.then(res => handleSuccess(res))
				.catch(handleError);
		}
	}, []);

	const handleSuccess = React.useCallback((previewInfos: PreviewInfo[]) => {
		setPreviewInfos(previewInfos.map(previewInfo => ({link: previewInfo.link, item: previewInfo})));
		onSuccess && onSuccess();
	}, []);

	const handleError = React.useCallback((err) => {
		onError && onError();
	}, []);
	
	return (
		<div>
			{
				previewInfos.map(item => 
					<LinkPreviewComponent key={`link-preview-${uuid()}`} previewInfo={item.item} />)
			}
		</div>
	);
};

export default LinkPreviewGroup;